<template>
  <div class="">
    <ul class="tablist">
      <li class="tabmenu" @click="goPageByName('point')">포인트 적립내역</li>
      <li class="tabmenu" @click="goPageByName('pointuse')">포인트 전환신청</li>
      <li class="tabmenu current" @click="goPageByName('pointuselist')">포인트 전환내역</li>
    </ul>
    <!--ul class="strbtnPT lastnone mb20">
      <li>{{$t('front.point.leftPoint')}}<span>{{thousand(sum ? sum.pointAmt: 0)}} P</span></li>
      <li>{{$t('front.point.monthPoint')}}<span>{{thousand(sum ? sum.thisMonthPoint : 0)}} P</span></li>
      <li>{{$t('front.point.prevMonthPoint')}}<span>{{thousand(sum ? sum.preMonthPoint: 0)}} P</span></li>
      <li>{{$t('front.point.allPoint')}}<span>{{thousand(sum ? sum.totalInPoint : 0)}} P</span></li>
      <li>{{$t('front.point.allUsePoint')}}<span>{{thousand(sum ? sum.totalOutPoint : 0)}} P</span></li>
      <li></li>
    </ul-->
    <div class="PTsch">
     <div class="datesearchPT">
        <date-filter @search="loadList(1)"
                     @update="onChangeDate"
                     :startDate="searchDate.startDate"
                     :endDate="searchDate.endDate"/>
        <button class="dateBtn" @click="loadList(1)">{{ $t('front.give.search') }}</button>
     </div>
     <div class="datesearchM">
        <date-filter-mobile @search="loadList"
                     @update="onChangeDate" />
        <button class="dateBtn" @click="loadList(1)">{{ $t('front.give.search') }}</button>
     </div>
    </div>

    <div class="strTablescr">
     <div class="strTablePC">
        <table class="strTablePT">
          <colgroup>
            <col width="20%">
            <col width="20%">
            <col width="20%">
            <col width="20%">
            <col width="20%">
          </colgroup>
          <thead>
            <tr>
              <th>{{$t('front.board.applyDay')}}</th>
              <th>{{$t('front.board.divUse')}}</th>
              <th>{{$t('front.board.applyPoint')}}</th>
              <th>{{$t('front.board.processDay')}}</th>
              <th>{{$t('front.board.processState')}}</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="list.length > 0">
              <template v-for="item in list" :key="item.updDt">
                <tr>
                  <td>{{dateFormatAll(item.regDt)}}</td>
                  <td>{{$t('front.board.moneychange')}}</td>
                  <td>{{thousand(item.point_inAmt.replace('-', ''))}}</td>
                  <td>{{dateFormatAll(item.updDt)}}</td>
                  <td>{{$t('front.board.complet')}}</td>
                </tr>
              </template>
            </template>
            <template v-else>
              <tr>
              </tr>
            </template>
          </tbody>
        </table>
     </div>
     <!-- <div class="strTableM">
        <div class="strTablePTM">
           <template v-if="list.length > 0">
             <template v-for="item in list" :key="item.updDt">
               <ul>
                 <li><em>{{$t('front.board.applyDay')}}</em>{{dateFormatAll(item.regDt)}}</li>
                 <li><em>{{$t('front.board.divUse')}}</em>{{$t('front.board.moneychange')}}</li>
                 <li><em>{{$t('front.board.applyPoint')}}</em>{{thousand(item.point_inAmt.replace('-', ''))}}</li>
                 <li><em>{{$t('front.board.processDay')}}</em>{{dateFormatAll(item.updDt)}}</li>
                 <li><em>{{$t('front.board.processState')}}</em>{{$t('front.board.complet')}}</li>
               </ul>
             </template>
           </template>
           <template v-else>
             <ul>
                <li class="nodata">{{$t('front.common.notFoundList')}}</li>
             </ul>
           </template>
        </div>
     </div> -->
  </div>

    <pagination
        :pageNum="pageInfo.page"
        :pageSize="pageInfo.count_per_list"
        :totalCount="pageInfo.tatal_list_count"
        @goToPage="loadList" />

  </div>
</template>

<script>
import DateFilter from '@/components/ui/DateFilter'
import DateFilterMobile from '@/components/ui/DateFilterMobile'
import Pagination from '@/components/ui/Pagination'
import { getPointList } from '@/api/point'

export default {
  name: 'pointUselist',
  components: { DateFilter, DateFilterMobile, Pagination },
  data () {
    return {
      list: [],
      sum: {},
      pageInfo: {
        page: 1,
        count_per_list: 10,
        tatal_list_count: 0
      }
    }
  },
  created () {
    this.loadList()
  },
  methods: {
    loadList (page) {
      const params = {
        pointType: 'out',
        page: page || this.pageInfo.page,
        startDate: this.searchDate.startDate,
        endDate: this.searchDate.endDate
      }

      console.log(params)

      getPointList(params).then(response => {
        const result = response.data
        if (result.resultCode === '0') {
          if (result.data.pageInfo) {
            this.pageInfo = result.data.pageInfo
          }
          const data = result.data
          this.list = data.list
          this.sum = data.sum
        }
      })
    }
  }
}
</script>
<style scoped>
.boardw li:nth-child(2){word-break: break-all;}
</style>
<style src="@/styles/striNew.css"></style>
<style scoped>
.tablist {
  display: flex !important;
  align-items: center !important;
  gap: 12px !important;
  margin: 24px 0 18px !important;
  padding: 0 !important;
  list-style: none !important;
}

.tabmenu {
  min-width: 136px !important;
  height: 38px !important;
  padding: 0 18px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  border: 1px solid #dbe3ef !important;
  border-radius: 6px !important;
  background: #ffffff !important;
  color: #111827 !important;
  font-size: 15px !important;
  font-weight: 800 !important;
  letter-spacing: -0.4px !important;
  box-shadow: 0 3px 10px rgba(15, 23, 42, 0.04) !important;
  cursor: pointer !important;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

.tabmenu:hover {
  border-color: #b8c7dd !important;
  background: #f8fafc !important;
}

.tabmenu.current {
  border-color: #5669d8 !important;
  background: #5669d8 !important;
  color: #ffffff !important;
  box-shadow: 0 8px 16px rgba(86, 105, 216, 0.18) !important;
}

.PTsch {
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
  min-height: 54px !important;
  margin: 0 0 18px !important;
  padding: 12px 14px !important;
  border: 1px solid #dbe3ef !important;
  border-radius: 10px !important;
  background: #ffffff !important;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.05) !important;
}

.datesearchPT {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  width: 100% !important;
  min-width: 0 !important;
}

.datesearchM {
  display: none !important;
}

.PTsch :deep(.datesearch),
.PTsch :deep(.dateFilter),
.PTsch :deep(.date-filter) {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  flex-wrap: wrap !important;
}

.PTsch :deep(input),
.PTsch :deep(select) {
  height: 30px !important;
  padding: 0 10px !important;
  border: 1px solid #d4ddeb !important;
  border-radius: 5px !important;
  background: #ffffff !important;
  color: #253044 !important;
  font-size: 13px !important;
  box-sizing: border-box !important;
  outline: none !important;
}

.PTsch :deep(input:focus),
.PTsch :deep(select:focus) {
  border-color: #5b7ee5 !important;
  box-shadow: 0 0 0 3px rgba(91, 126, 229, 0.13) !important;
}

.PTsch :deep(button:not(.dateBtn)) {
  height: 30px !important;
  min-width: 52px !important;
  padding: 0 12px !important;
  border: 1px solid #5f6978 !important;
  border-radius: 4px !important;
  background: #5f6978 !important;
  color: #ffffff !important;
  font-size: 13px !important;
  font-weight: 800 !important;
}

.dateBtn {
  height: 30px !important;
  min-width: 54px !important;
  margin-left: 4px !important;
  padding: 0 14px !important;
  border: 1px solid #d69400 !important;
  border-radius: 5px !important;
  background: #d69400 !important;
  color: #ffffff !important;
  font-size: 13px !important;
  font-weight: 900 !important;
  box-shadow: 0 4px 10px rgba(214, 148, 0, 0.16) !important;
  cursor: pointer !important;
}

.strTablescr {
  margin-top: 0 !important;
  padding: 0 !important;
  border: 1px solid #dbe3ef !important;
  border-radius: 10px !important;
  background: #ffffff !important;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.05) !important;
  overflow: hidden !important;
}

.strTablePC {
  width: 100% !important;
  overflow-x: auto !important;
}

.strTablePT {
  width: 100% !important;
  min-width: 980px !important;
  border-collapse: collapse !important;
  table-layout: fixed !important;
  background: #ffffff !important;
}

.strTablePT th,
.strTablePT td {
  height: 43px !important;
  padding: 10px 12px !important;
  border: 0 !important;
  border-bottom: 1px solid #e2e8f0 !important;
  color: #1f2937 !important;
  font-size: 13px !important;
  line-height: 1.35 !important;
  text-align: center !important;
  vertical-align: middle !important;
  box-sizing: border-box !important;
}

.strTablePT th {
  height: 46px !important;
  background: #ffffff !important;
  color: #111827 !important;
  font-weight: 900 !important;
}
.strTablePT thead tr {
  border-top: 3px solid #2f6df6;
  border-radius: 10px 10px 0 0;
}
.strTablePT tbody tr:nth-child(2n) {
  background: #f7f8fa !important;
}

.strTablePT tbody tr:hover {
  background: #eef6ff !important;
}

.strTablePT tbody tr:empty::after {
  content: '데이터가 없습니다.';
  display: table-cell;
  height: 46px;
  color: #64748b;
  text-align: center;
  vertical-align: middle;
}

:deep(.pagination),
:deep(.partnerPaging) {
  margin-top: 18px !important;
}

@media (max-width: 1000px) {
  .tablist {
    flex-wrap: wrap !important;
    gap: 8px !important;
    margin-top: 16px !important;
  }

  .tabmenu {
    flex: 1 1 calc(33.333% - 8px) !important;
    min-width: 0 !important;
    padding: 0 10px !important;
    font-size: 13px !important;
  }

  .PTsch {
    padding: 12px !important;
  }

  .datesearchPT {
    display: none !important;
  }

  .datesearchM {
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
    width: 100% !important;
  }

  .strTablePT {
    min-width: 760px !important;
  }
}
@media (max-width: 1092px) {
  .tablist .tabmenu{
    width: calc(100% / 3 - 6px);
    white-space: nowrap;
  }
}
@media (max-width: 520px) {
  .tablist .tabmenu{
    font-size: 12px;
    min-width: auto;
  }
}
</style>
